module.exports = __webpack_public_path__ + "img/mysql.314fa60d.svg";